module.exports = __webpack_public_path__ + "static/media/Living-4.99d4efe4.webp";